<template>
  <div class="widget-action box box--shadow">
    <div class="containingDiv" :style="colorBackground">
      <h3 v-html="title">{{title}}</h3>
      <p v-html="body"></p>
      <div class="button p-3">
        <router-link v-if="to" class="btn btn-outline-primary" :to="to">{{callToAction}}</router-link>
        <a v-else @click.prevent="emitClick()" class="btn btn-outline-primary" href="#">{{callToAction}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetAction',
  props: ['title', 'body', 'callToAction', 'to', 'background'],
  computed: {
    colorBackground () {
      if (this.background) {
        return 'background-color: ' + this.background + '; padding-left:60px; padding-right:60px;'
      }
      return ''
    }
  },
  methods: {
    emitClick () {
      console.log('Widget click')
      this.$emit('onClick')
    }
  }
}
</script>

<style scoped lang="scss">
  h3 {
    color: #00193D;	
    font-family: Roboto;	
    font-size: 18px;	
    font-weight: 500;	
    line-height: 21px;	
    text-align: center;
  }

  .widget-action{
    padding: 6px !important;
    text-align: center;
    font-size: 16px;

    @media (min-width:992px) {
      padding: 1.625rem 1rem 1.5rem 1rem;
    }
  }

  .containingDiv{
    width: 100%;
    height: 100%;
    padding: 2rem 24px 24px 24px
  }

  .box {
    position: relative;
    height: 100%;
    display:flex;
    flex-wrap:wrap;
    justify-content:center;
    align-items:space-between;
    margin-bottom:0px;
  }

  .widget-action-content {

    

    h3 {
      margin-bottom:0.5rem;
    }

    p {
      color: #00193D;
    }
  }

  .widget-action-button {
    width: 100%;
    display:flex;
    justify-content:center;
    align-items:flex-end;
    padding: 0.5rem 1rem 0 1rem;
    //padding: 0.5rem 0 0 0;

    .btn {
      width:100%;
      max-width:230px;
      display:inline-block;
    }

    @media (min-width:992px) {
      padding: 0.5rem 0 0 0;

      .btn {
        width:100%;
        max-width: 200px;
      }
    }

  }


</style>
 


// WEBPACK FOOTER //
// src/components/widgets/WidgetAction.vue